<template>
  <div class="vertical grow gallery-container" style="width: 35vw; height: 100%">
        <div style="margin-top: 20px;">
            <div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td class="title-td" style="width:200px;"><p class="info-field-title">{{ $t('MainAssignee') }}</p></td>
                        <td style="width:400px;" class="info-field-value">
                            <select v-model="ticketInfo.assignedFarmerId" style="width: 100%">
                                <option v-for="n in systemUserNames" :key="n.id" :value="n.id">
                                    {{n.name}}
                                </option>
                            </select>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td class="title-td"  style="width:200px;"><p class="info-field-title">{{ $t('Subject') }}</p></td>
                        <td style="width:400px;" class="info-field-value">
                            <textarea v-model="ticketInfo.subject" type="text" :placeholder="$t('Subject')" style="height: 50px; width: 100%"/>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td class="title-td" style="width:200px;"><p class="info-field-title">{{ $t('Content') }}</p></td>
                        <td style="width:400px;" class="info-field-value">
                            <textarea v-model="ticketInfo.content" type="text" :placeholder="$t('Content')" style="width: 100%"/>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td class="title-td" style="width:200px;"><p class="info-field-title">{{$t('Photos')}}</p></td>
                        <td style="width:400px;" class="info-field-value">
                            <!-- Natywny input był nieprzetłumaczony („Choose files”) i po usunięciu zdjęcia dalej pokazywał starą liczbę plików. -->
                            <div class="ticket-photos">
                                <div v-for="(photo, index) in photos" :key="photo.url" class="ticket-photos__item">
                                    <img :src="photo.url" alt="">
                                    <button type="button" class="ticket-photos__remove" :title="$t('Remove')" @click="deletePhoto(index)">×</button>
                                </div>
                                <button type="button" class="ticket-photos__add" :title="$t('AddPhotos')" @click="$refs.fileInput.click()">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>
                                    <span>{{ $t('AddPhotos') }}</span>
                                </button>
                            </div>
                            <input ref="fileInput" type="file" id="problemPhotoId" name="problemPhoto" accept="image/*" class="ticket-photos__file" @change="addPhoto" multiple>
                        </td>
                    </tr>
                </div>
                <div style="justify-content: center; margin-bottom: 10px;" class="horizontal">
                    <div class="error" v-if="error != ''">{{ error }}</div>
                </div>
            </div>
        </div>
        <div style="align-self: center; margin-bottom: 20px;">
            <Button :title="$t(saving ? 'Sending' : 'Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" :disabled="saving" @onClick="save"></Button>
        </div>
    </div>
</template>

<script>

import { getSystemUsersNames, postNewTicket } from '@api';
import DatePicker from 'vue2-datepicker';
import Button from '../../Button.vue';
import { sendErrorKey } from './ticketChat';

export default {
    props: {
        systemId: {
            type: String,
            required: true
        }
    },
    components: {
        DatePicker,
        Button
    },
    data() {
        return {
            ticketInfo: {
                systemId: '',
                subject: '',
                content: '',
                assignedFarmerId: ''
            },
            error: '',
            systemUserNames: [],
            photos: [],
            saving: false
        }
    },
    methods: {
        async getData() {
            this.systemUserNames = await getSystemUsersNames(this.systemId)

            if(this.systemUserNames.length == 1) {
                this.ticketInfo.assignedFarmerId = this.systemUserNames[0].id
            }
        },
        async save() {
            if (this.saving) return;

            this.checkDataCorrectness()

            if(this.error != "") {
                return;
            }

            this.ticketInfo.systemId = this.systemId;
            var toSend = Object.assign({}, this.ticketInfo)
            var form = new FormData()
            var keys = Object.keys(toSend)
            for(let i = 0; i < keys.length; i++){
                form.append(keys[i], toSend[keys[i]])
            }

            var photosSrc = this.photos.map(x => x.src)
            for(let i = 0; i < photosSrc.length; i++) {
                form.append("resources", photosSrc[i])
            }
            // Blokada na czas wysyłki — zdjęcia idą kilka sekund, a drugi klik tworzył drugie zgłoszenie.
            this.saving = true;
            try {
                await postNewTicket(form)
            } catch(e) {
                this.error = this.$i18n.t(sendErrorKey(e, photosSrc.length > 0));
                return;
            } finally {
                this.saving = false;
            }
            this.$emit('saved')
        },
        checkDataCorrectness() {
            this.error = ""

            if(this.ticketInfo.assignedFarmerId == '') {
                this.error = this.$i18n.t("AssigneeNotSelected");
                return;
            }

            if(this.ticketInfo.subject == ''){
                this.error = this.$i18n.t("SubjectNotFilled");
                return;
            }

            if(this.ticketInfo.content == '') {
                this.error = this.$i18n.t("ContentNotFilled");
                return;
            }

        },
        sortSystemsByName(a, b){
			return (a.name.localeCompare(b.name, undefined, {
              numeric: true,
              sensitivity: 'base'
            }));
		},
		addPhoto(e){
            Array.from(e.target.files)
                .filter(f => f.type != null && f.type.startsWith('image/'))
                .forEach(file => this.photos.push({ src: file, url: URL.createObjectURL(file) }));
            // Ten sam plik wybrany drugi raz (np. po usunięciu) też ma wywołać change.
            e.target.value = '';
        },
        deletePhoto(index) {
            URL.revokeObjectURL(this.photos[index].url);
            this.photos.splice(index, 1);
        },
    },
    beforeDestroy() {
        this.photos.forEach(p => URL.revokeObjectURL(p.url));
    },
    async mounted() {
        this.getData()
    }
}
</script>

<style scoped>
.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.section-title {
    font-weight: bold;
    text-align: center;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
    justify-content: center;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    align-self: center;
    width: 80%;
    margin: 0;
    padding-bottom: 5px;
}

.section-title {
    font-weight: bold;
}

select {
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

textarea {
    height: 200px;
    max-height: 300px;
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

.info-field-row > td {
    vertical-align: middle;
}

.error {
    font-size: 14px;
}
</style>

<style scoped>
.info-field-value {
    width: 100%;
}

.ticket-photos {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 4px 0 10px;
}

.ticket-photos__item {
    position: relative;
    width: 72px;
    height: 72px;
}

.ticket-photos__item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
}

.ticket-photos__remove {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 50%;
    background: var(--danger);
    color: #fff;
    line-height: 18px;
    font-size: 14px;
    padding: 0;
    cursor: pointer;
}

.ticket-photos__add {
    width: 72px;
    height: 72px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    border: 1px dashed var(--input-border);
    border-radius: 6px;
    background: transparent;
    color: var(--text-muted);
    font-size: 11px;
    line-height: 13px;
    text-align: center;
    cursor: pointer;
}

.ticket-photos__add:hover {
    border-color: var(--accent);
    color: var(--accent);
}

.ticket-photos__file {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/Tickets/TicketModal.vue